import { nanoid } from 'nanoid/async'
import { openaiModal } from './openaiModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: textData } = await openaiModal(oldData, node)

  if (textData && textData.textMessage.length > 0) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, textData)

    node.update()
    updateNodeConnections(node)
  }

  return false
}